<script>
    export default {
        name: 'NormalMask',
        props: {transparent: {type: Boolean}},
        render () {
            const {transparent, className, ...others} = this;
            const clz = this.$util.classNames({
                'normal-mask': !transparent,
                'normal-mask_transparent': transparent,
                [className]: className
            });
            return <div class={clz} {...others}></div>;
        }
    };

</script>

<style lang="less" scoped>
    .normal-mask {
        position: fixed;
        z-index: 1000;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
    }
</style>
